import React from 'react';
import moment from 'moment';
import PrintableReport from '../../components/printableReport.jsx';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import events from 'lib/events';
import ReportApi from 'api/report';

class AnaLysisByEmployeeSummary extends React.Component {
  static propTypes = {
    intl: intlShape,
    filters: PropTypes.object,
  };

  state = {};

  getDateRange = () => {
    const {formatMessage} = this.props.intl;

    let dateFrom = moment(this.props.filters.dateFrom).format(dateTimeFormats.numeralDate);
    let dateTo = moment(this.props.filters.dateTo).format(dateTimeFormats.numeralDate);

    return formatMessage({id: 'general.date.range'}, {
      start: dateFrom,
      end: dateTo,
    });
  };

  getSubTypes = subTypes => {
    return <div>
      {subTypes.map(i => <h6 key={i}>{i}</h6>)}
    </div>;
  };

  export = () => {
    let filters = this.props.filters;

    ReportApi.getOutboundEmailsReport(
      this.props.intl.locale,
			filters.dateFrom,
			filters.dateTo,
			filters.branch,
		);
  };

  printReport = data => {
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'general.email.type'}), key: 'EmailType'},
      {name: formatMessage({id: 'general.sent'}), key: 'SentCount'},
      {name: formatMessage({id: 'general.opened'}), key: 'OpenedCount'},
      {name: formatMessage({id: 'general.email.not.sent'}), key: 'NoEmailSentCount'},
    ];

    return <PrintableReport
      columns={columns}
      end={moment(this.props.filters.dateTo).format(dateTimeFormats.numeralDate)}
      endLabel={formatMessage({id: 'general.end.date'})}
      start={moment(this.props.filters.dateFrom).format(dateTimeFormats.numeralDate)}
      startLabel={formatMessage({id: 'general.start.date'})}
      report={data}
      title='Outbound Emails'
    />;
  };

  render() {

    let tableRows;
    let data = this.props.data;
    let {formatMessage} = this.props.intl;

    const dateRange = <FormattedMessage id='general.date.range.labelled' values={{
      start: moment(this.props.filters.dateFrom).format(dateTimeFormats.numeralDate),
      end: moment(this.props.filters.dateTo).format(dateTimeFormats.numeralDate),
    }}/>;

    if(data && Object.keys(data).length) {
      tableRows = data.map((row, i) =>
        <tr key={i} className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td className={row.SubTypes.length > 0 ? 'icon-column' : 'hidden-icon'}>
            <ToolTip title={this.getSubTypes(row.SubTypes)}
                        position={tooltipPositions.topLeft} iconClass={'bl bl-add'} iconOnly />
          </td>
          <td>{row.EmailType}</td>
          <td className="table-number">{row.SentCount}</td>
          <td className="table-number">{row.OpenedCount}</td>
          <td className="table-number">{row.NoEmailSentCount}</td>
        </tr>
			);
    }

    return <div>
      <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <span className={Object.keys(data).length && this.props.filters ? 'summary-date' : 'not-show'}> | {dateRange}
        </span>
        <br/>
        <span><FormattedMessage id="reports.reveal.report.summary"/></span>
        {this.props.showNoDataMessage ?
          <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
        <div className="container-fluid custom-container-margins">
          <div className={data && Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            <table className="summary-table">
              <tbody>
                <tr className="table-title">
                  <th/>
                  <th><FormattedMessage id="general.email.type"/></th>
                  <th className="table-number"><FormattedMessage id="general.sent"/></th>
                  <th className="table-number"><FormattedMessage id="general.opened"/></th>
                  <th className="table-number"><FormattedMessage id="general.email.not.sent"/>&nbsp;<ToolTip
                  topRight
                  iconOnly
                  invert
                  body={formatMessage({id: 'reports.outbound.emails.tooltip'})}/>
                  </th>
                </tr>
                {tableRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group'>
        <button className='btn btn-default pull-right'
                disabled={data && Object.keys(data).length <= 0}
                onClick={() => {
                  events.publish('print', this.printReport(this.props.data));
                }}><FormattedMessage id="reports.print.summary"/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

export default injectIntl(AnaLysisByEmployeeSummary);
